import React, { createContext, useContext, useState } from "react";
import { Link2 } from "lucide-react";
import EventWorkspace from "../components/platform/EventWorkspace";

const WorkspaceContext = createContext({ openWorkspace: () => {} });

export const useWorkspace = () => useContext(WorkspaceContext);

// One shared Connected Event Workspace host for the whole app: every Hub opens the
// same experience through openWorkspace({ type, id }).
export function WorkspaceProvider({ children }) {
  const [anchor, setAnchor] = useState(null);
  return (
    <WorkspaceContext.Provider value={{ openWorkspace: setAnchor }}>
      {children}
      <EventWorkspace anchor={anchor} onClose={() => setAnchor(null)} />
    </WorkspaceContext.Provider>
  );
}

// Drop-in "Connections" button for Hub record pages.
export function ConnectionsButton({ type, id, className = "", compact = false }) {
  const { openWorkspace } = useWorkspace();
  if (!id) return null;
  return (
    <button data-testid={`connections-btn-${type}`} onClick={() => openWorkspace({ type, id })}
      title="Open the connected event workspace"
      className={className || `flex items-center gap-1.5 rounded-xl border border-[#E2E8F0] px-3 py-1.5 text-xs font-medium text-[#636E72] transition-colors hover:border-[#0F766E]/40 hover:text-[#0F766E] ${compact ? "px-2" : ""}`}>
      <Link2 className="h-3.5 w-3.5" />
      {!compact && "Connections"}
    </button>
  );
}
